import { render, staticRenderFns } from "./NextTestTeacher.vue?vue&type=template&id=6328da79&scoped=true"
import script from "./NextTestTeacher.vue?vue&type=script&lang=js"
export * from "./NextTestTeacher.vue?vue&type=script&lang=js"
import style0 from "./NextTestTeacher.vue?vue&type=style&index=0&id=6328da79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6328da79",
  null
  
)

export default component.exports